import { addDays, startOfToday } from 'date-fns';

import {
  defaultDateInputFormats,
  displayFormat,
} from '../../utils/date-formats';
import { DateAggregator } from './types/date-aggregator.type';
import { DateRange } from './types/date-range.type';

export interface DateRangePickerState {
  value: DateRange;
  content: DateAggregator;
  message: string;
  minDate: Date;
  maxDate: Date;
  scheduleExtensionMessage: string;
  dateDisplayFormat: string;
  dateInputFormats: string[];
  showValidationErrors: boolean;
  seasonalRouteMessage: string;
  departErrorMessage?: string;
  returnErrorMessage?: string;
  months?: any;
  showSchedule?: boolean;
  keepCalendarOpen?: boolean;
  showPricing?: boolean;
  placement?: 'bottom-start' | 'bottom-end'; // JbFlyoutPlacementEnum
}

export const dateRangePickerComponentInitialState: DateRangePickerState = {
  value: {
    startDate: null,
    endDate: null,
  },
  scheduleExtensionMessage: '',
  content: undefined,
  message: '',
  minDate: addDays(startOfToday(), 3),
  maxDate: addDays(startOfToday(), 365),
  dateDisplayFormat: displayFormat,
  dateInputFormats: [displayFormat, ...defaultDateInputFormats],
  showValidationErrors: false,
  seasonalRouteMessage: '',
  placement: 'bottom-start',
  keepCalendarOpen: false,
  showPricing: true,
  months: [
    {
      startDate: new Date('2021-10-01T05:00:00.000Z'),
      days: [
        {
          date: new Date('2021-10-01T05:00:00.000Z'),
          isAvailable: true,
          displayText: '129',
        },
        {
          date: new Date('2021-10-02T05:00:00.000Z'),
          isAvailable: false,
          displayText: '131',
        },
      ],
    },
  ],
};
